// ----------------------------------------------------------------------------
// Component: Timeline Slider
// ----------------------------------------------------------------------------
//
// A timeline slider with Content Panel block
//
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';
import Swiper, { Navigation, Pagination, A11y } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/a11y';
import './_timeline-slider.scss';



// -------------------------------------
// Variables
// -------------------------------------

// -------------------------------------
// Hooks
// -------------------------------------
function handleSlides(swiperEl) {
    swiperEl.slides.forEach(function(slide, index) {
        let slideLink = slide.querySelector('a');
        slideLink.addEventListener('focus', function(e) {
            swiperEl.slideTo(index);
        })
    });
}

$(function() {
    $(".carousel--timeline-slider").each(function(index, element){
        var $this = $(this);

        // Generate unique class for each collection list slider
        $this.addClass("timeline-slider-instance-" + index);

        // Generate unique btn classes for slider arrows
        $this.parents('.timeline-slider').find(".swiper-button-prev").addClass("timeline-slider-btn-prev-" + index);
        $this.parents('.timeline-slider').find(".swiper-button-next").addClass("timeline-slider-btn-next-" + index);

        var swiper = new Swiper(".timeline-slider-instance-" + index, {
            // Optional parameters
            modules: [Navigation, Pagination, A11y],
            slidesPerView: 1,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.

            // // Navigation arrows
            navigation: {
              nextEl: ".timeline-slider-btn-next-" + index,
              prevEl: ".timeline-slider-btn-prev-" + index
            },

            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: 'true'
            },
        });

        swiper.slides.forEach(function(slide, index) {
            let slideLink = slide.querySelector('a');
            slideLink.addEventListener('focus', function(e) {
                swiper.slideTo(index);
            })
        });
    });
});
